import { render, staticRenderFns } from "./StudentAvatar.vue?vue&type=template&id=5a126afd"
import script from "./StudentAvatar.vue?vue&type=script&lang=js"
export * from "./StudentAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports